import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { paymentState, setPaymentData } from '../store/slices/payment';
import yesNoData from '../constants/yes-no';

import { useTranslation } from 'react-i18next';

import { creditCardValidation, expirationDateValidation, whitespaceValidation } from '../helpers/validation';
import BasePage from './BasePage';

import { RadioInput, TextInput } from '../components';

/**
* Page that holds payment form
*/
const PaymentPage = () => {
  const { t } = useTranslation('payment');
  const dispatch = useDispatch();
  const { paymentOptions, payment } = useSelector(paymentState);
  const isCreditCard = payment.paymentMethod?.value === 'credit_card';

  const onPaymentInput = (name, value) => dispatch(setPaymentData({ ...payment, [name]: value }));
  return (
    <BasePage
      title={t('title')}
      navigation={{
        secondary: {
          path: '/product',
          text: t('secondaryButton')
        },
        primary: {
          path: '/thankYou',
          text: t('primaryButton')
        }
      }}>
      <div className='page__container'>
        <RadioInput
          name='paymentMethod'
          defaultValue={payment.paymentMethod}
          options={{ data: paymentOptions.methodList }}
          validation={{ required: t('form.paymentMethod.required') }}
          onSelect={onPaymentInput}
        />
      </div>
      {
        isCreditCard && <div className='page__container'>
          <TextInput
            name='cardNumber'
            defaultValue={payment.cardNumber}
            label={t('form.cardNumber.label')}
            width={70}
            keyboard='number'
            validation={{
              required: t('form.cardNumber.required'),
              validate: (value) => (creditCardValidation(value) || t('form.cardNumber.invalid'))
            }}
            mask={[{ custom: 'creditCard', length: 0 }]}
            onBlur={onPaymentInput}
          />
          <TextInput
            name='cvv'
            defaultValue={payment.cvv}
            label={t('form.cvv.label')}
            width={30}
            keyboard='number'
            validation={{ required: t('form.cvv.required') }}
            mask={[{ pattern: '0000', length: 0 }]}
            onBlur={onPaymentInput}
          />
          <TextInput
            name='cardName'
            defaultValue={payment.cardName}
            label={t('form.cardName.label')}
            width={70}
            validation={{
              required: t('form.cardName.required'),
              validate: (value) => (whitespaceValidation(value) || t('form.cardName.invalid'))
            }}
            onBlur={onPaymentInput}
          />
          <TextInput
            name='dueDate'
            defaultValue={payment.dueDate}
            label={t('form.dueDate.label')}
            width={30}
            keyboard='number'
            validation={{
              required: t('form.dueDate.required'),
              validate: (value) => (expirationDateValidation(value) || t('form.dueDate.invalid'))
            }}
            mask={[{ pattern: '00/0000', length: 0 }]}
            onBlur={onPaymentInput}
          />
        </div>
      }
      <div className='page__container'>
        <RadioInput
          name='autoRenew'
          defaultValue={payment.autoRenew}
          label={t('form.autoRenew.label')}
          options={{ data: yesNoData }}
          validation={{ required: t('form.autoRenew.required') }}
          onSelect={onPaymentInput}
        />
      </div>
    </BasePage>
  );
}
export default PaymentPage;